/* ============================================================
   LIMBER LUMBAR — Theme JS
   ============================================================ */

(function () {
  'use strict';

  /* ── Scroll header shadow ──────────────────────────────── */
  const header = document.querySelector('.site-header');
  if (header) {
    let lastScroll = 0;
    window.addEventListener('scroll', () => {
      const current = window.scrollY;
      header.classList.toggle('scrolled', current > 0);
      lastScroll = current;
    }, { passive: true });
  }

  /* ── Mobile nav drawer ─────────────────────────────────── */
  const menuToggle  = document.querySelector('.header__menu-toggle');
  const mobileNav   = document.querySelector('.mobile-nav');
  const mobileClose = document.querySelector('.mobile-nav__close');
  const backdrop    = document.querySelector('.mobile-nav-backdrop');

  if (menuToggle && mobileNav) {
    menuToggle.addEventListener('click', () => {
      mobileNav.classList.add('is-open');
      if (backdrop) backdrop.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    });
  }
  if (mobileClose) mobileClose.addEventListener('click', closeMobileNav);
  if (backdrop) backdrop.addEventListener('click', closeMobileNav);

  // Close on link click inside drawer
  document.querySelectorAll('.mobile-nav__group a, .mobile-nav__cta a').forEach(link => {
    link.addEventListener('click', closeMobileNav);
  });

  function closeMobileNav() {
    if (mobileNav) mobileNav.classList.remove('is-open');
    if (backdrop) backdrop.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  /* ── Smooth scroll for anchor links ───────────────────── */
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
      const target = document.querySelector(this.getAttribute('href'));
      if (target) {
        e.preventDefault();
        const offset = header ? header.offsetHeight : 0;
        const top = target.getBoundingClientRect().top + window.scrollY - offset - 16;
        window.scrollTo({ top, behavior: 'smooth' });
      }
    });
  });

  /* ── Quantity selector ─────────────────────────────────── */
  document.querySelectorAll('.product-form__qty').forEach(qty => {
    const input = qty.querySelector('input');
    const minus = qty.querySelector('[data-action="minus"]');
    const plus  = qty.querySelector('[data-action="plus"]');

    if (minus && input) {
      minus.addEventListener('click', () => {
        const v = parseInt(input.value, 10) || 1;
        if (v > 1) input.value = v - 1;
      });
    }
    if (plus && input) {
      plus.addEventListener('click', () => {
        const v = parseInt(input.value, 10) || 1;
        input.value = v + 1;
      });
    }
  });

  /* ── Add to cart, then send shoppers straight to cart ──── */
  const ajaxForms = document.querySelectorAll('.product-form[data-ajax]');
  const cartUrl = '/cart';

  ajaxForms.forEach(form => {
    form.addEventListener('submit', async function (e) {
      e.preventDefault();

      const btn = form.querySelector('[type="submit"]');
      const originalText = btn.textContent;
      btn.disabled = true;
      btn.textContent = 'Adding…';

      try {
        const formData = new FormData(form);

        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Accept': 'application/json' },
          body: formData
        });

        if (!response.ok) {
          const err = await response.json().catch(() => ({}));
          throw new Error(err.description || 'Cart add failed');
        }

        window.location.href = cartUrl;
      } catch (err) {
        btn.textContent = 'Try again';
        btn.disabled = false;
        console.error(err);
      }
    });
  });

  /* ── Cart notification ─────────────────────────────────── */
  const notification = document.getElementById('cart-notification');

  function showCartNotification() {
    if (!notification) return;
    notification.hidden = false;
    requestAnimationFrame(() => notification.classList.add('is-visible'));
    setTimeout(hideCartNotification, 4000);
  }

  function hideCartNotification() {
    if (!notification) return;
    notification.classList.remove('is-visible');
    setTimeout(() => { notification.hidden = true; }, 300);
  }

  const notifClose = notification && notification.querySelector('.cart-notification__close');
  if (notifClose) notifClose.addEventListener('click', hideCartNotification);

  /* ── Scroll reveal ─────────────────────────────────────── */
  if ('IntersectionObserver' in window) {
    const revealObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          revealObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });

    document.querySelectorAll('.reveal').forEach(el => revealObserver.observe(el));
  } else {
    // Fallback for older browsers
    document.querySelectorAll('.reveal').forEach(el => el.classList.add('is-visible'));
  }

})();
